export default __webpack_public_path__ + "alberta-sort-timestamp-new.f7efc25d0c33c0af0b2c.svg";